/******** faq section *******/


var $question_one = $('.accordion_head');
var $answer_one = $('.accordion_body');
$question_one.click(function() {
  // Hide all answers
  $answer_one.slideUp();
  // Check if this answer is already open
  if ($(this).hasClass('active')) {
      // If already open, remove 'open' class and hide answer
      $(this).removeClass('active').next($answer_one).slideUp();
      // If it is not open...
  } else {
      // Remove 'open' class from all other questions
      $question_one.removeClass('active');
      // Open this answer and add 'open' class
      $(this).addClass('active').next($answer_one).slideDown();
  }
});

// product page code*******************************
$(".Select-Quantity .SQ_box .quantity:first-child").addClass('active');
  $('.Select-Quantity .SQ_box .quantity').click(function(){
    var chkclss=$(this).hasClass("active");
    if(chkclss==true){ 
        // $(this).removeClass("active");
        }
    else{
        $(".Select-Quantity .SQ_box .quantity").removeClass("active");
        $(this).addClass("active");
        }
    $('.Select-Quantity .SQ_box .quantity.active').each(function() {
    var val_qut = $(this).attr("data-quantity");
    var val_text = $(this).attr("name");
    $( ".js-qty__wrapper input.js-qty__num" ).val( val_qut );
   $('fieldset.variant-input-wrap .variant-input[data-value="'+ val_text +'"]').find("label.variant__button-label").trigger("click");
      var varprice = $(".product-single__variants option:selected").attr('data-price');
      $('.SS_price_dft span').text(varprice);
    });
});
//$('ul.tabnav li:first-child a').addClass('active');
$('.tabcontent').first().show();


$(document).on('change', '.tabber-section .tabnav li input', function(){
  var target = $(this).closest('a').attr('href');
  $('.tabber-section .tabnav li a').removeClass('active');
    $(this).closest('a').addClass('active');
  $(target).show().siblings('.tabcontent').hide();
  var value = $(this).val();
  // if(value == 'Subscribe'){
  //   $('label.appstle_radio_label span.appstle_subscribe_save_text').trigger("click");
  // }
  // else{
  //   $('label.appstle_radio_label span.appstle_one_time_text').trigger("click");
  // }
   });


//   $(document).on('change', 'select#Delivery', function(){
//   var vals = $(this).find('option:selected').val();
 

// var data= $(".appstleRadioSellingPlanWrapper>div span.sellingplan[dat_val='"+vals+"']").addClass('sss');

//   });
//    });



$('.tabnav input[type=radio]').change(function() {
   if (this.value == 'Subscribe') {
        $('.product__thumb-item img[alt="20off"]').trigger("click");
    }
    else if (this.value == 'One-time') {
        $('.product__thumb-item[data-index="0"] img').trigger("click");
    }
});
// product page code*******************************end

// $(document).on("click","ul li a#Fordeler",function(){
// $('html, body').animate({
// scrollTop: $("#NavFordeler").offset().top
// }, 1500);
// });
//       $(document).on("click"," ul li a#Uttalelser",function(){
// $('html, body').animate({
// scrollTop: $(".js-oke-widgetSize.oke-is-large").offset().top
// }, 1500);
// });
//       $(document).on("click"," ul li a#Ingredienser",function(){
// $('html, body').animate({
// scrollTop: $("#NavIngredienser").offset().top
// }, 1500);
// });
//       $(document).on("click"," ul li a#OfteStilteSpørsmål",function(){
// $('html, body').animate({
// scrollTop: $("#NavFAQ").offset().top
// }, 1500);
// });
//       $(document).on("click",".Excellent",function(){
// $('html, body').animate({
// scrollTop: $(".okeReviews.oke-w").offset().top
// }, 1500);
// }); 
//       $(document).on("click",".reviews-app-header .inner",function(){
// $('html, body').animate({
// scrollTop: $(".okeReviews.oke-w").offset().top
// }, 1500);
// }); 
// $("a.SS_btn_popup.Click-here").on('click', function() {
//   $(".SS_popup.custom-model-main").addClass('model-open');
// }); 
// $(".SS_popup .close-btn, .SS_popup .bg-overlay").click(function(){
//   $(".SS_popup.custom-model-main").removeClass('model-open');
// });
//  **************sticky button code**************
$(document).ready(function() {
  $(window).scroll(function() {
    if ($(document).scrollTop() > 1500) {
      $(".btn_sticky").addClass("active");
    } else {
      $(".btn_sticky").removeClass("active");
    }

      if($(window).scrollTop() + $(window).height() == $(document).height()) {
       //you are at bottom
      $(".btn_sticky").removeClass("active");
   }
    else{
            //$(".btn_sticky").removeClass("active");
    }
  });
});
//  **************sticky button code end**************
$(".drawer__contents .mobile-nav li a").on('click', function() {
  $('#NavDrawer').removeClass('drawer--is-open');
  $('html').removeClass('js-drawer-open');
  $('html').removeClass('lock-scroll');
  // $('button.site-nav__link').trigger( "click" );
});

$(document).on("click", ".sticky-block button", function(event){
    event.preventDefault()
    $('.product-block .add-to-cart').trigger('click');
});
// -----------------sell_plan

var IntID =setInterval(function() {
   $("<div class='dropdown'></div>").insertBefore(".appstleRadioSellingPlanWrapper");
  var text =$('.appstleRadioSellingPlanWrapper div:first-child label span.sellingplan').text(); 
  $('.dropdown').text(text); 
    $('label.appstle_radio_label span.appstle_subscribe_save_text').trigger("click");
   var cls=$('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle_selected_background');
//    $("<div class='ship_txt_append'></div>").insertAfter(".appstle_subscribe_option");
// var sub_text =$('.Subscribe_Save .SS_sub-plan').html();
// $('.ship_txt_append').append(sub_text);
   if(cls == true){
       clearInterval(IntID);  
   }
}, 100);

$(document).on("click",".appstleRadioSellingPlanWrapper div label",function() {
    var txt =$(this).find('span.sellingplan').text();
    $('.dropdown').empty();
    $('.dropdown').text(txt);
    $('.appstleRadioSellingPlanWrapper ').removeClass('active');
  $('.dropdown').removeClass('arrow');
   });
$(document).on("click",".variant-wrapper .variant-input",function() {    
  setTimeout(function() {  
    if($('.dropdown').length){
   
    }
    else{
      $("<div class='dropdown'></div>").insertBefore(".appstleRadioSellingPlanWrapper");
    }
  var text =$('.appstleRadioSellingPlanWrapper div:first-child label span.sellingplan').text(); 
  $('.dropdown').text(text);  
    }, 100);
});

 $(document).on("click",".dropdown",function() {
   $(this).toggleClass('arrow'); 
 $('.appstleRadioSellingPlanWrapper').toggleClass('active');   
});
$(document).on("click",".appstle_subscription_wrapper_option.appstle_include_dropdown label.appstle_radio_label",function() { 
$('.ship_txt_append').remove();
$("<div class='ship_txt_append'></div>").insertAfter(".appstle_subscribe_option");
  var sub_text =$('.Subscribe_Save .SS_sub-plan').html();

$('.ship_txt_append').append(sub_text);
});
$(document).on("click",".appstle_subscription_wrapper .appstle_subscription_wrapper_option:first-child label.appstle_radio_label",function() {
 var html_one_time =$('.tabcontent-wrapper .tabcontent.one_time p').text(); 
$('.appstle_one_time_description_text').text(html_one_time);
});
// $(document).on("click",".variant-wrapper .variant-input",function() {
//   var html_one_time =$('.tabcontent-wrapper .tabcontent.one_time p').text(); 
//   console.log(html_one_time);
//     setTimeout(function() {  
//   $('.appstle_one_time_description_text').text(html_one_time);
//       $('.ship_txt_append').remove();
// $("<div class='ship_txt_append'></div>").insertAfter(".appstle_subscribe_option");
//   var sub_text =$('.Subscribe_Save .SS_sub-plan').html();
// $('.ship_txt_append').append(sub_text);
// $(".appstle_subscription_wrapper").removeClass("one-time");
//         }, 100);
// });

$(document).on("click",".variant-wrapper .variant-input",function() {
  var html_one_time =$('.tabcontent-wrapper .tabcontent.one_time p').text(); 
  console.log(html_one_time);
    setTimeout(function() {  
      if($('.appstle_subscription_wrapper').hasClass("one-time")){
       $('.appstle_subscription_wrapper .appstle_one_time_details_wrapper label').trigger('click');
        $(".appstle_subscription_wrapper").addClass("one-time");
         $('.appstle_one_time_description_text').text(html_one_time);
      $('.ship_txt_append').remove();
      $("<div class='ship_txt_append'></div>").insertAfter(".appstle_subscribe_option");
        var sub_text =$('.Subscribe_Save .SS_sub-plan').html();
      $('.ship_txt_append').append(sub_text);
      }
      else{
         $('.appstle_one_time_description_text').text(html_one_time);
      $('.ship_txt_append').remove();
      $("<div class='ship_txt_append'></div>").insertAfter(".appstle_subscribe_option");
        var sub_text =$('.Subscribe_Save .SS_sub-plan').html();
      $('.ship_txt_append').append(sub_text);
      $(".appstle_subscription_wrapper").removeClass("one-time");
      }
        }, 100);
  
});

document.addEventListener("DOMContentLoaded", () => {
  function apploaded(){
  var intervalId = setInterval(function() {
    var RechargeContainer = document.querySelector('.appstleRadioSellingPlanWrapper');
    if (RechargeContainer) {
     $(".appstle-radio-wrapper:first-child label").trigger('click');
      
      $(document).on('click','.SS_btn_popup',function(){
          $('.SS_popup').addClass('show-popup');
      });
      $(document).on('click','.SS_popup .close-btn',function(){
          $('.SS_popup').removeClass('show-popup');
      }); 
      clearInterval(intervalId);
    } else {
    }
  }, 1000);
  }
apploaded();

 
});






















